import { useState, useEffect } from "react";
import {
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import { useLazyOpenGateQuery } from '@/api/enterance';
import { useGetOpenReasonSettingQuery } from '@/api/adminServiceApi';
import { useSelector } from 'react-redux';
import { selectActiveBuildingId } from '@/features/building/buildingSlice';
import {
  Key as KeyIcon
} from "@mui/icons-material"
import SnackAlert from '@/components/snack-alert';
import { useTranslation } from "react-i18next";
import ActionButton from "./ActionButton"
// TODO Выяснить почему алерт использовался от другого компонента - setCheckError, setCheckErrorMessage

// TODO: заменить временный список причин на согласованный с колл-центром
const OPEN_REASON_OPTIONS = [
  'technical_failure',
  'client_forgot_pass',
  'payment_error',
  'force_majeure',
  'other',
]

const ActionButtonOpen = ({
  channelId,
  onCheckError,
}) => {
  const {t} = useTranslation();
  const activeBuildingId = useSelector(selectActiveBuildingId);
  const { data: openReasonSetting } = useGetOpenReasonSettingQuery(
    activeBuildingId,
    { skip: !activeBuildingId }
  );
  const requireOpenReason = Boolean(openReasonSetting?.require_open_reason);

  const [getOpenGate, result] = useLazyOpenGateQuery();
  const [openAlert, setOpenAlert] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [reasonDialogOpen, setReasonDialogOpen] = useState(false);
  const [selectedReason, setSelectedReason] = useState('');
  const [customReason, setCustomReason] = useState('');

  const finalReason =
    selectedReason === 'other' ? customReason.trim() : selectedReason
  const canSubmitReason = Boolean(finalReason);

  const executeOpen = async (id, reason) => {
    try {
      await getOpenGate({ channelId: id, reason }).unwrap()
      setShowSuccess(true)
    } catch (error) {
      console.error('Ошибка открытия ворот:', error);
      onCheckError(error?.data?.message || 'Ошибка соединения с сервером (502)');
    }
  }

  const handleOpenGate = (id) => () => {
    if (requireOpenReason) {
      setSelectedReason('')
      setCustomReason('')
      setReasonDialogOpen(true)
      return
    }
    executeOpen(id, '')
  }

  const handleCloseReasonDialog = () => {
    setReasonDialogOpen(false)
  }

  const handleConfirmReason = async () => {
    if (!canSubmitReason) return
    await executeOpen(channelId, finalReason)
    setReasonDialogOpen(false)
  }

  const onCloseSuccess = (event, reason) => {
    if (reason === 'clickaway') return
    setShowSuccess(false)
  }

  useEffect(() => {
    if (result.isSuccess) {
      setOpenAlert(true)
    }
  }, [result.isSuccess]);

  return (
    <>
      <ActionButton
        color="primary"
        startIcon={<KeyIcon/>}
        onClick={handleOpenGate(channelId)}
        >
          {t('open')}
      </ActionButton>

      <Dialog
        open={reasonDialogOpen}
        onClose={handleCloseReasonDialog}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>{t('specify_open_reason')}</DialogTitle>
        <DialogContent>
          <FormControl fullWidth>
            <InputLabel id="open-reason-select-label">
              {t('specify_open_reason')}
            </InputLabel>
            <Select
              labelId="open-reason-select-label"
              value={selectedReason}
              label={t('specify_open_reason')}
              onChange={(e) => setSelectedReason(e.target.value)}
            >
              {OPEN_REASON_OPTIONS.map((code) => (
                <MenuItem key={code} value={code}>
                  {t(`open_reason_${code}`)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {selectedReason === 'other' && (
            <TextField
              fullWidth
              multiline
              minRows={2}
              sx={{ mt: 1 }}
              label={t('open_reason_custom_label')}
              value={customReason}
              onChange={(e) => setCustomReason(e.target.value)}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseReasonDialog}>
            {t('cancel')}
          </Button>
          <Button
            variant="contained"
            disabled={!canSubmitReason || result.isFetching}
            onClick={handleConfirmReason}
          >
            {t('open')}
          </Button>
        </DialogActions>
      </Dialog>

      <SnackAlert
        open={openAlert}
        onClose={() => setOpenAlert(false)}
        message={
          result.isSuccess ? t('the_gate_is_open') : t('something_went_wrong')
        }
        variant="filled"
        severity={result.isSuccess ? 'success' : 'error'}
      />
      <Snackbar
        open={result.data?.message === 'Success!' && showSuccess}
        autoHideDuration={3000}
        onClose={onCloseSuccess}
      >
        <Alert
          sx={{ width: '100%' }}
          severity="success"
          variant="filled"
          onClose={onCloseSuccess}
        >          
          {t('gate_open')}
        </Alert>
      </Snackbar>
    </>
  )
}

export default ActionButtonOpen;
